export default new Proxy({}, {
  get(_, key) {
    throw new Error(`Module "crypto" has been externalized for browser compatibility. Cannot access "crypto.${key}" in client code.`)
  }
})